// @ts-nocheck
import React from 'react';
import classnames from 'classnames';

import RadioButton from 'dpl/components/RadioButton';
import ClickableDiv from 'dpl/common/components/ClickableDiv';
import Icon from 'dpl/common/components/Icon';

interface SelectPaymentTypeRadioProps {
  title: string;
  icon: string;
  name: string;
  listItems: string[];
  onSelect: () => void;
  isSelected: boolean;
  fee?: string | null;
  onChangeModalClick?:
    | ((modalName: string, allowGoBack?: boolean) => void)
    | null;
}

export default function SelectPaymentTypeRadio({
  title,
  icon,
  name,
  fee = null,
  onSelect,
  isSelected,
  listItems,
  onChangeModalClick = null
}: SelectPaymentTypeRadioProps) {
  return (
    <ClickableDiv onClick={onSelect}>
      <div
        className={classnames('SelectPaymentTypeRadio ba br3 pv4 ph6 tl', {
          'b--lightest-gray': !isSelected
        })}
      >
        <div className="flex justify-between">
          <div className="flex align-items-center mb2">
            <div className="ba br-100 bg-teal-light b--subtle-gray padding-h-6 padding-v-6">
              <Icon
                name={icon}
                height="20px"
                width="20px"
                className="green-dark-700"
              />
            </div>
            <h5 className="font-18 md:font-20 ml2 lh-normal">{title}</h5>
            {fee && <span className="font-14 mid-gray ml2">{fee}</span>}
          </div>
          <RadioButton
            id={name}
            name={name}
            value={title}
            isChecked={isSelected}
            onClick={() => {}}
          />
        </div>
        <div className="row">
          <div className="mb2">
            <ul className="nv1 nv2-sm ml4 col-11 font-14 md:font-16">
              {listItems.map((item, idx) => (
                <li key={idx} className="list--disc-outside mv1 mv2-sm">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          {onChangeModalClick && (
            <div className="w-100 bt b--lightest-gray">
              <button
                type="button"
                className="col-11 font-14 md:font-16 underline stone-700 mt4"
                onClick={() => onChangeModalClick('learnMore', true)}
              >
                Learn more
              </button>
            </div>
          )}
        </div>
        <div />
      </div>
    </ClickableDiv>
  );
}
